<div class="flex-center h-100">
  <div class="flex-justify-center flex-align-center onboarding-step-container h-100 w-100">
    <div class="flex-justify-center gap-M h-100 w-100 h-auto m-auto">
      @if (!isMobile()) {
        <div class="onboarding-stepper-container flex-column gap-M mt-l">
          <div class="onboarding-stepper active-step"></div>
          @if (stepCount() >= 2) {
            <div class="onboarding-stepper"></div>
          }
          @if (stepCount() >= 3) {
            <div class="onboarding-stepper"></div>
          }
          @if (stepCount() >= 4) {
            <div class="onboarding-stepper"></div>
          }
          @if (stepCount() >= 5) {
            <div class="onboarding-stepper"></div>
          }
          @if (stepCount() >= 6) {
            <div class="onboarding-stepper"></div>
          }
        </div>
      }
      <div class="onboarding-step flex-column flex-space-between w-30 gap-L border-box pad-L">
        <div class="h-100">
          @if (canClose()) {
            <div class="flex-justify-end">
              <app-icon-button (click)="goBackHome()" img='assets/icons/close.svg' size='s' color='accent' type='stroked'
                shape='default' [disabled]='false' [focused]='false'
              [background]='true' panelClass='img-size-30'></app-icon-button>
            </div>
          }
          <div class="flex-center mb-xxl mt-xxl">
            <img src="assets/onboarding/illustration-1.svg" class="onboarding-illustration" alt="ill1">
          </div>
          <div class="font-XXL text-center mb-xxl onboarding-title">
            <span>{{ 'page.onboarding.welcome' | translate }}&nbsp;</span>
            <span class="fw-700">{{ currentUser.firstName }}</span>
          </div>
          <div class="flex-justify-center text-center font-L fw-300" [style.line-height.px]="panelClass() === 'big-button' ? 27 : 23">
            <div class="onboarding-subtitle">
              <span class="fw-700">{{ 'page.onboarding.step1.st1' | translate }}</span>{{ 'page.onboarding.step1.st2' | translate }}<span class="fw-700">{{ 'page.onboarding.step1.st3' | translate }}</span>
              {{ 'page.onboarding.step1.st4' | translate }}<span class="fw-700">{{ 'page.onboarding.step1.st5' | translate }}</span>
            </div>
          </div>
        </div>
        <div class="flex-center w-100 pb-l">
          <app-text-button (click)="onNextClick.emit('Step 2')" class="w-95" color='accent' type='flat'
            shape='default' [disabled]='false' [loading]='false' badge=''
            badgePosition='above after' [panelClass]="panelClass()">{{ 'page.onboarding.step1.st6' | translate }}
          </app-text-button>
        </div>
      </div>
    </div>
  </div>
</div>
